'use client';

import { motion } from 'framer-motion';

// Perf notes:
// - Only animate `x` / `y` (transform). Scaling a blurred element forces the
//   browser to re-rasterize the filter every frame — the #1 killer of smoothness.
// - Blur radii kept ≤80px. Above that, Chromium switches to a slower path.
// - `willChange: transform` promotes each blob to its own composited layer.
const blobStyle = { willChange: 'transform' } as const;

export default function HeroAurora() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      <motion.div
        className="absolute rounded-full bg-[hsl(var(--primary)/0.40)]"
        style={{ width: 480, height: 480, top: '5%', left: '8%', filter: 'blur(80px)', ...blobStyle }}
        animate={{ x: [0, 80, -30, 0], y: [0, -60, 40, 0] }}
        transition={{ duration: 22, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute rounded-full bg-[hsl(var(--accent)/0.35)]"
        style={{ width: 560, height: 560, bottom: '0%', right: '0%', filter: 'blur(80px)', ...blobStyle }}
        animate={{ x: [0, -90, 50, 0], y: [0, 50, -70, 0] }}
        transition={{ duration: 28, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute rounded-full bg-[hsl(var(--ring)/0.28)]"
        style={{ width: 380, height: 380, top: '40%', left: '45%', filter: 'blur(70px)', ...blobStyle }}
        animate={{ x: [0, 60, -80, 0], y: [0, 70, -30, 0] }}
        transition={{ duration: 32, repeat: Infinity, ease: 'easeInOut' }}
      />
    </div>
  );
}
